import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=69594604&scoped=true"
import script from "./SelectProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectProduct.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69594604",
  null
  
)

export default component.exports